import React from "react";

import StatTypes from "types/StatTypes";

import LabelStatsRow from "components/LabelStatsRow";
import MaxStatsRow from "components/MaxStatsRow";
import NormalStatsRow from "components/NormalStatsRow";
import NormalStatsWithoutLabelRow from "components/NormalStatsWithoutLabelRow";
import PercentageStatsRow from "components/PercentageStatsRow";
import CircularStatsRow from "components/CircularStatsRow";

type Props = { data: StatTypes; numberOfSection: number };

function StatsComponent({ data, numberOfSection }: Props): JSX.Element {
  if (!data.toggle) return <></>;

  if (data?.type?.name === "label") {
    return <LabelStatsRow data={data} numberOfSection={numberOfSection} />;
  }
  if (data?.type?.name === "normal") {
    // @ts-ignore
    return <NormalStatsRow data={data} numberOfSection={numberOfSection} />;
  }
  if (data?.type?.name === "normalWithoutLabel") {
    return (
      <NormalStatsWithoutLabelRow
        data={data}
        numberOfSection={numberOfSection}
      />
    );
  }
  if (data?.type?.name === "circular") {
    return <CircularStatsRow data={data} numberOfSection={numberOfSection} />;
  }
  if (data?.type?.name === "max") {
    return <MaxStatsRow data={data} numberOfSection={numberOfSection} />;
  }
  if (data?.type?.name === "percentage") {
    // @ts-ignore
    return <PercentageStatsRow data={data} numberOfSection={numberOfSection} />;
  }

  if (data?.type?.name === "children") {
    return data?.children;
  }

  return <></>;
}

export default StatsComponent;
